export default __webpack_public_path__ + "static/media/lsp-energi.4ff25424.png";